import { getDocuments } from '../services/documents'

// just an example of how the requests will work with getDocuments
const getNotifications = async () => {
  const data = await getDocuments('notification/chargeBox?limit=100')
  return data
}

const getNotificationsByChargeBoxId = async (chargeBoxId) => {
  const data = await getDocuments(`notification/chargeBox?chargeBoxIds=${chargeBoxId}&limit=30`)
  return data
}

const getNotificationsByUserPk = async (userPk) => {
  const data = await getDocuments(`notification/chargeBox?userPk=${userPk}&limit=30`)
  return data
}

export { getNotifications, getNotificationsByChargeBoxId, getNotificationsByUserPk }
